import { makeStyles } from "@material-ui/core/styles";
import styled from "styled-components";
import ZeroAmountMessage from "./components/ZeroAmountMessage";
import PaymentForm from "./pages/PaymentForm";
import QuoteDetails from "./pages/QuoteDetails";

import { useMediaQuery } from "react-responsive";
import { breakpoints } from "../../styles/breakpoints";
import { Desktop } from "../../utils/media-queries";
import ServiceBotHeader from "../service-bot-header.component";

const ScrollContainer = styled.div`
  box-sizing: border-box;
  overflow-y: auto;
  width: 100%;
  height: 100%;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    height: "100%",
    overflow: "hidden",
  },
  desktop: {
    maxWidth: "100%",
    width: "100%",
    margin: "auto",
    boxSizing: "border-box",
  },
  mobile: {
    width: "100%",
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  stepNav: {
    display: "flex",
    gap: theme.spacing(1),
    padding: theme.spacing(1, 2, 2),
    width: "100%",
    boxSizing: "border-box",
  },
  stepTab: {
    flex: 1,
    minHeight: 48,
    padding: theme.spacing(1.5, 1),
    fontSize: 15,
    fontWeight: 600,
    fontFamily: "'Open Sans', sans-serif",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    borderRadius: 8,
    border: "2px solid #bdbdbd",
    backgroundColor: "#fff",
    color: "#424242",
    cursor: "pointer",
    transition:
      "background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease",
    "&:focus": {
      outline: "none",
    },
    "&:focus-visible": {
      outline: "3px solid rgb(53, 151, 236)",
      outlineOffset: 2,
    },
  },
  stepTabSelected: {
    backgroundColor: "rgb(53, 151, 236)",
    color: "#fff",
    borderColor: "rgb(21, 101, 192)",
    boxShadow: "0 2px 6px rgba(21, 101, 192, 0.35)",
  },
}));

function getSteps() {
  return ["PROPOSAL", "CHECKOUT"];
}

function renderDesktopProposalCheckout(props) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        overflowX: "hidden",
        width: "90%",
        maxWidth: "90%",
        marginLeft: "auto",
        marginRight: "auto",
        boxSizing: "border-box",
      }}
    >
      <div style={{ flex: "1 1 60%", minWidth: 0 }}>
        <QuoteDetails
          {...props}
          key="quote-details-desktop-split"
          disableAnimate
        />
      </div>
      <div
        style={{
          flex: "1 1 40%",
          minWidth: 0,
          paddingLeft: 16,
          boxSizing: "border-box",
        }}
      >
        {props.allTotal > 0 ? (
          <PaymentForm {...props} desktopSplitLayout />
        ) : (
          <ZeroAmountMessage />
        )}
      </div>
    </div>
  );
}

function QuoteMobileTabletStepNav({ steps, activeStep, setStep, classes }) {
  return (
    <div
      className={classes.stepNav}
      role="tablist"
      aria-label="Proposal and checkout steps"
    >
      {steps.map((label, index) => {
        const selected = activeStep === index;
        return (
          <button
            key={label}
            type="button"
            role="tab"
            aria-selected={selected}
            id={`quote-step-tab-${index}`}
            aria-controls="quote-step-panel"
            className={`${classes.stepTab} ${selected ? classes.stepTabSelected : ""}`}
            onClick={() => setStep(index)}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}

function getStepContent(step, props, isDesktop) {
  if (isDesktop && !props.convertedSale) {
    return renderDesktopProposalCheckout(props);
  }

  switch (step) {
    case 0:
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            overflowX: "hidden",
          }}
        >
          <Desktop>
            <div style={{ flex: 1 }} />
          </Desktop>
          <QuoteDetails
            {...props}
            key={`dakey${Math.random()}`}
            disableAnimate={isDesktop}
          />
          <Desktop>
            <div style={{ paddingLeft: 10 }}>
              {!props.convertedSale && props.allTotal > 0 && (
                <PaymentForm {...props} />
              )}
              {!props.convertedSale && props.allTotal <= 0 && (
                <ZeroAmountMessage />
              )}
            </div>
          </Desktop>
        </div>
      );
    case 1:
      if (!props.convertedSale && props.allTotal <= 0) {
        return <ZeroAmountMessage />;
      }
      return !props.convertedSale && <PaymentForm {...props} />;
    case 2:
      return "Checkout";
    default:
      return "Unknown step";
  }
}

export default function QuoteStepperHorizontal(props) {
  const classes = useStyles();
  const activeStep = props.currentStep;
  const steps = getSteps();

  const isDesktop = useMediaQuery({ minWidth: breakpoints.lg });

  return (
    <div
      className={`${classes.root} ${
        isDesktop ? classes.desktop : classes.mobile
      }`}
    >
      <ScrollContainer>
        {isDesktop ? (
          <ServiceBotHeader {...props} />
        ) : (
          <QuoteMobileTabletStepNav
            steps={steps}
            activeStep={activeStep}
            setStep={props.setStep}
            classes={classes}
          />
        )}

        <div
          id="quote-step-panel"
          role="tabpanel"
          aria-label={isDesktop ? "Proposal and payment" : undefined}
          aria-labelledby={
            isDesktop ? undefined : `quote-step-tab-${activeStep}`
          }
        >
          {activeStep === steps.length ? (
            <div />
          ) : (
            <div>{getStepContent(activeStep, props, isDesktop)}</div>
          )}
        </div>
      </ScrollContainer>
    </div>
  );
}
